import { css } from 'emotion'

export const UpdateTeamNameFormStyles = css``
